import { BatchSuggestionWithGroupsSchema } from "@redotech/redo-model/fulfillments/batch-suggestion";
import { AdvancedFilterInputSchema } from "@redotech/redo-model/outbound-labels/fulfillment-group-summary-input";
import * as z from "zod";

export const getBatchSuggestionByKey = {
  name: "getBatchSuggestionByKey" as const,
  input: z.object({
    batchKey: z.string(),
    advancedFiltersInput: AdvancedFilterInputSchema,
  }),
  output: z.object({ suggestion: BatchSuggestionWithGroupsSchema.nullish() }),
};
